var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-control"
  }, [_c('filter-by-period', {
    ref: "periodFilter",
    attrs: {
      "label": 'Obdobie'
    },
    on: {
      "period-filter-change-1": function periodFilterChange1($event) {
        return _vm.handlePeriodChange($event);
      }
    }
  }), _vm.role === 'alex_admin' ? _c('filter-by-employee', {
    ref: "employeeFilter",
    attrs: {
      "label": 'bankár',
      "employees": _vm.financnici
    },
    on: {
      "employee-filter-change": function employeeFilterChange($event) {
        return _vm.handleFinancnkChange($event);
      }
    }
  }) : _vm._e(), _c('search-by-key', {
    ref: "searchFilter",
    on: {
      "filter-client-by-key": function filterClientByKey($event) {
        return _vm.handleSearchChange($event);
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }